var _this = this;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var Swal = require(261);
var URL = require(270);
var isSANB = require(160);
var qs = require(215);
var superagent = require(257);
var Spinner = require(28);

// Ajax form submission with frisbee
// and sweetalert2 message response
// and built-in support for Stripe Checkout
// eslint-disable-next-line complexity
var ajaxForm = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(ev) {
    var $form, spinner, $email, $token, handler, $btns, action, method, headers, body, url, state, pageNumber, searchParameters, isSameState, _iterator, _step, key, value, isSame, response, config, tableSelector, $table;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // Prevent default form submission
          ev.preventDefault();

          // Get the form
          $form = $(ev.currentTarget); // Return early if we're using `confirm-prompt` plugin
          // and it has not yet been confirmed
          if (!(($form.hasClass('confirm-prompt') || $form.data('toggle') === 'confirm-prompt') && !$form.data('confirmed'))) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", false);
        case 4:
          // Initialize spinner
          spinner = new Spinner($); // Const api = new Frisbee({
          //   baseURI: window.location.origin,
          //   headers: defaultHeaders
          // });
          // If the form requires Stripe checkout token
          // then return early and open Stripe checkout
          if (!$form.hasClass('stripe-checkout')) {
            _context.next = 17;
            break;
          }
          if (window.StripeCheckout) {
            _context.next = 8;
            break;
          }
          throw new Error('StripeCheckout global missing');
        case 8:
          // Lookup email input for later
          $email = $form.find('input[name="stripe_email"]'); // If there is already a token then continue
          $token = $form.find('input[name="stripe_token"]');
          if (!($token.length === 0)) {
            _context.next = 12;
            break;
          }
          throw new Error('Stripe token field missing');
        case 12:
          if (!($token.val() === '')) {
            _context.next = 17;
            break;
          }
          // Fetch token for the user
          handler = window.StripeCheckout.configure({
            key: window.STRIPE_PUBLISHABLE_KEY,
            image: window.STRIPE_CHECKOUT_IMAGE_URL,
            locale: window.LOCALE || 'auto',
            token: function token(_token) {
              // You can access the token ID with `token.id`.
              // get the token ID to your server-side code for use
              $token.val(_token.id);
              // Also included is `token.email`
              // which we append to the form if
              // there is an `input[name=email]`
              if ($email.length > 0) $email.val(_token.email);
              ajaxForm.call(_this, ev);
            }
          });
          handler.open(_objectSpread({
            allowRememberMe: false
          }, $form.data()));
          $(window).on('popstate', function () {
            return handler.close();
          });
          return _context.abrupt("return");
        case 17:
          // Show the spinner
          spinner.show();

          // Disable submit button so we can't resubmit the form
          $btns = $form.find('input[type="submit"], button[type="submit"]');
          $btns.prop('disabled', true).addClass('disabled');

          // Determine the path we're sending the request to
          action = $form.is('a') ? $form.attr('href') : $form.attr('action'); // If the action is missing a starting forward slash then append it
          if (action.indexOf('/') !== 0) action = "/".concat(action);

          // Determine the method of the HTTP request
          method = $form.attr('method'); // Default to GET request
          if (!method) method = 'GET';

          // Take into account method override middleware
          if (method === 'POST' && $form.find('input[name="_method"]').length > 0) method = $form.find('input[name="_method"]').val();

          // Consider that DELETE needs to be mapped to DEL since fetch uses `.del`
          if (method === 'DELETE') method = 'DEL';
          _context.prev = 26;
          headers = {
            'X-CSRF-Token': window._csrf,
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }; // If the form contains a file input, then we need to use FormData
          // otherwise we can just use querystring parsing to assemble body
          body = {};
          if ($form.find('input[type="file"]').length > 0) {
            body = new FormData(_this);
            // Delete _csrf and _method from the body
            // since they are defined in headers and http method
            body["delete"]('_csrf');
            body["delete"]('_method');
            // Remove content-type header so boundary is added for multipart forms
            // http://stackoverflow.com/a/35799817
            headers['Content-Type'] = undefined;
            delete headers['Content-Type'];
          } else {
            body = qs.parse($form.serialize());
            // Delete _csrf and _method from the body
            // since they are defined in headers and http method
            delete body._csrf;
            delete body._method;
          }

          // Update the querystring for ajax tables
          if ($form.hasClass('table-ajax-form')) {
            url = new URL(window.location.href); // Create state
            state = qs.parse(url.query, {
              ignoreQueryPrefix: true
            });
            pageNumber = $form.data('page');
            if (pageNumber) {
              state.page = pageNumber;
            }

            // Data search-params should be a ',' delimited string
            searchParameters = $form.data('search-params');
            searchParameters = isSANB(searchParameters) ? searchParameters.split(',') : [];

            // Determine if states are the same
            isSameState = Boolean(window.history.state);
            _iterator = _createForOfIteratorHelper(searchParameters);
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                key = _step.value;
                value = body instanceof FormData ? body.get(key) : body[key]; // Set page number to undefined if key has changed
                isSame = state[key] === value;
                state.page = isSame ? state.page : undefined;
                state[key] = isSANB(value) ? value : value === '' ? undefined : state[key];
                if (isSameState && !isSame) isSameState = false;
              }

              // Security check to prevent _csrf ever being added to querystring
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            if (state._csrf) delete state._csrf;
            state = qs.stringify(state);
            url.set('query', state);

            // Remove undefined properties
            state = isSANB(state) ? qs.parse(state) : undefined;
            if (isSameState || !state) {
              window.history.replaceState(state, "state ".concat(window.history.length), url.toString());
            } else {
              window.history.pushState(state, "state ".concat(window.history.length), url.toString());
            }

            // Add the refactored querystring to action
            action = url.toString();
          }

          // NOTE: this does not support retries/timeout yet
          // Send the request
          _context.next = 33;
          return superagent[method.toLowerCase()](action).set(headers).ok(function () {
            return true;
          }) // Override so we can parse it ourselves
          .send(body);
        case 33:
          response = _context.sent;
          // Taken from Frisbee
          // attempt to use better and human-friendly error messages
          if (!response.ok) {
            response.err = new Error(response.statusText || response.text || 'Unsuccessful HTTP response');
            if (_typeof(response.body) === 'object' && response.body !== null && typeof response.body.message === 'string') {
              response.err = new Error(response.body.message);
            } else if (!Array.isArray(response.body) && _typeof(response.body) === 'object' && response.body !== null &&
            // Attempt to utilize Stripe-inspired error messages
            _typeof(response.body.error) === 'object') {
              if (response.body.error.message) response.err = new Error(response.body.error.message);
              if (response.body.error.stack) response.err.stack = response.body.error.stack;
              if (response.body.error.code) response.err.code = response.body.error.code;
              if (response.body.error.param) response.err.param = response.body.error.param;
            }
          }

          // Check if any errors occurred
          if (!response.err) {
            _context.next = 37;
            break;
          }
          throw response.err;
        case 37:
          if (!(_typeof(response.body) !== 'object' || response.body === null)) {
            _context.next = 42;
            break;
          }
          // Hide the spinner
          spinner.hide();
          // Show message
          Swal.fire(window._types.error, 'Invalid response, please try again', 'error');
          _context.next = 76;
          break;
        case 42:
          if (!isSANB(response.body.redirectTo)) {
            _context.next = 57;
            break;
          }
          if (!(typeof response.body.autoRedirect === 'boolean' && response.body.autoRedirect || !isSANB(response.body.message) && _typeof(response.body.swal) !== 'object')) {
            _context.next = 48;
            break;
          }
          // Reset the form
          if (typeof response.body.resetForm === 'boolean' && response.body.resetForm) $form.get(0).reset();
          // Redirect
          window.location = response.body.redirectTo;
          _context.next = 55;
          break;
        case 48:
          // Hide the spinner
          spinner.hide();
          // Reset the form
          if (typeof response.body.resetForm === 'boolean' && response.body.resetForm) $form.get(0).reset();
          config = {};
          config = _typeof(response.body.swal) === 'object' ? response.body.swal : {
            title: isSANB(response.body.title) ? response.body.title : window._types.success,
            type: isSANB(response.body.type) ? response.body.type : 'success',
            html: response.body.message
          };
          // Show message
          _context.next = 54;
          return Swal.fire(config);
        case 54:
          // Redirect
          window.location = response.body.redirectTo;
        case 55:
          _context.next = 76;
          break;
        case 57:
          if (!(_typeof(response.body.swal) === 'object')) {
            _context.next = 63;
            break;
          }
          // Hide the spinner
          spinner.hide();
          // Show message
          Swal.fire(response.body.swal);
          // Reset the form
          if (typeof response.body.resetForm === 'boolean' && response.body.resetForm) $form.get(0).reset();
          _context.next = 76;
          break;
        case 63:
          if (!isSANB(response.body.message)) {
            _context.next = 75;
            break;
          }
          // Hide the spinner
          spinner.hide();
          // Reset the form
          if (typeof response.body.resetForm === 'boolean' && response.body.resetForm) $form.get(0).reset();
          // Reload page
          if (!(typeof response.body.reloadPage === 'boolean' && response.body.reloadPage)) {
            _context.next = 72;
            break;
          }
          _context.next = 69;
          return Swal.fire(window._types.success, response.body.message, 'success');
        case 69:
          window.location.reload();
          _context.next = 73;
          break;
        case 72:
          if (typeof response.body.renderModalBodyWithHTML === 'boolean' && response.body.renderModalBodyWithHTML) {
            $form.parents('.modal.show:first').find('.modal-body').html(response.body.message);
          } else {
            // Show message
            Swal.fire(window._types.success, response.body.message, 'success');
          }
        case 73:
          _context.next = 76;
          break;
        case 75:
          if (typeof response.body.reloadPage === 'boolean' && response.body.reloadPage) {
            window.location.reload();
          } else if ($form.hasClass('table-ajax-form') && isSANB(response.body.table)) {
            // Reload table
            tableSelector = $form.data('table');
            $table = $(tableSelector);
            $table.html(response.body.table);

            // dispatch an event so we can re-render things (e.g. dayjs)
            window.dispatchEvent(new Event('tableAjaxFormReloaded'));
            spinner.hide();
          } else {
            // Hide the spinner
            spinner.hide();
            // Show message
            Swal.fire(window._types.success, _typeof(response.body) !== 'object' || JSON.stringify(response.body) === '{}' ? response.text : JSON.stringify(response.body, null, 2), 'success');
          }
        case 76:
          if (_typeof(response.body) === 'object' && response.body !== null && typeof response.body.hideModal === 'boolean' && response.body.hideModal) {
            // Bootstrap 3
            $form.parents('.modal.in:first').modal('hide');
            // Bootstrap 4
            $form.parents('.modal.show:first').modal('hide');
          }
          _context.next = 83;
          break;
        case 79:
          _context.prev = 79;
          _context.t0 = _context["catch"](26);
          // Hide the spinner
          spinner.hide();

          // Show error message
          Swal.fire(window._types.error, _context.t0.message, 'error');
        case 83:
          _context.prev = 83;
          // Re-enable form buttons
          $btns.prop('disabled', false).removeClass('disabled');
          return _context.finish(83);
        case 86:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[26, 79, 83, 86]]);
  }));
  return function ajaxForm(_x) {
    return _ref.apply(this, arguments);
  };
}();
module.exports = ajaxForm;
//# sourceMappingURL=ajax-form.js.map